import React from 'react';
import './SearchFilter.css';

function SearchFilter({ searchQuery, setSearchQuery, selectedCategory, setSelectedCategory }) {
    // Updated list of available categories, matching those in UploadForm
    const categories = [
        'All', // Option to view all categories
        'CODM',
        'PUBG',
        'Crisis of Trust',
        'Others'
    ];

    // Handle changes to the search input
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle changes to the category select dropdown
    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
    };

    return (
        <div className="search-filter-container">
            <div className="search-input-group">
                <label htmlFor="search-input" className="visually-hidden">Search Videos</label>
                <input
                    type="text"
                    id="search-input"
                    className="search-input"
                    placeholder="Search by title or uploader..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                />
            </div>
            <div className="category-select-group">
                <label htmlFor="category-select" className="visually-hidden">Filter by Category</label>
                <select
                    id="category-select"
                    className="category-select"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                >
                    {categories.map((cat) => (
                        <option key={cat} value={cat}>{cat}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default SearchFilter;
